var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lni_lni-mobile",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.9,9.5h-5.8c-1.2,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3h5.8c1.2,0,2.3-1,2.3-2.3S36.1,9.5,34.9,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4,1.8H19.6c-3.4,0-6.3,2.8-6.3,6.3v48c0,3.4,2.8,6.3,6.3,6.3h24.9c3.4,0,6.3-2.8,6.3-6.3V8C50.7,4.6,47.9,1.8,44.4,1.8 z M46.2,56c0,1-0.8,1.8-1.8,1.8H19.6c-1,0-1.8-0.8-1.8-1.8V8c0-1,0.8-1.8,1.8-1.8h24.9c1,0,1.8,0.8,1.8,1.8V56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1,53.3C34,53.2,34,53.1,33.9,53c-0.1-0.1-0.2-0.2-0.3-0.3c-0.5-0.5-1.3-0.8-2-0.6c-0.1,0-0.3,0.1-0.4,0.1 c-0.1,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.3-0.2,0.4c-0.1,0.1-0.1,0.3-0.1,0.4 c0,0.1,0,0.3,0,0.4c0,0.6,0.2,1.2,0.7,1.6c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.3,0.1,0.4,0.1 c0.1,0,0.3,0,0.4,0c0.6,0,1.2-0.2,1.6-0.7c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0.2-0.4c0.1-0.1,0.1-0.3,0.1-0.4 c0-0.2,0-0.3,0-0.4c0-0.2,0-0.3,0-0.4C34.2,53.6,34.1,53.5,34.1,53.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.ed18db3cab076c78f958141ed3610b7f.svg";
export { ForwardRef as ReactComponent };